export default {
  container: {
    opacity: '0',
    animation: '0.6s fadeIn ease-in forwards'
  },
  table: {
    '& th': {
      textAlign: 'left',
      '& span': {
        height: '16px'
      }
    },
    '& td span': {
      height: '16px'
    },
    '& tr:hover td': {
      backgroundColor: 'transparent'
    }
  },
  received: {
    width: '66px'
  },
  conclusionCell: {
    textAlign: 'center !important',
    width: '20%'
  },
  conclusion: {
    width: '42px',
    textAlign: 'center'
  },
  titleCell: {
    width: '75%'
  },
  title: {
    width: '38px'
  },
  contextCell: {
    width: '60px'
  },
  center: {
    textAlign: 'center !important'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}
